import en from './en';
import cn from './cn';
import it from './it';

const values = {
  en: en,
  cn: cn,
  it: it
};


// 货币符号
const currencySymbols = {
  en: '€',
  cn: '¥',
  it: '€'
};


class Strings {

  getKey(key, ...args) {
    const language = this.getLanguage();
    // const value = values[language][key] || '???';

    let value = values[language][key] || key;

    if (typeof value === 'function') {
      return value(...args);
    }

    // 中文时截取第一个'/'后面的内容
    return language == 'cn' ? value.slice(value.indexOf('/') + 1) : value;
  }

  getLanguage() {
    return localStorage.getItem('language') || 'cn';
  }

  getCurrencySymbol() {
    return currencySymbols[this.getLanguage()] || '¥';
  }

  setLanguage(language) {
    localStorage.setItem('language', language);
  }

  get cs() {
    return this.getCurrencySymbol();
  }



  /**
   * vue插件：为全局定义$str对象和Translate方法，同时注册`Translate`组件
   */
  install(app) {
    const self = this
    app.config.globalProperties.$str = this
    app.component('Translate', {
      render(ctx) {
        return self.getKey(ctx.text)
      },
      data() {
        return {
          text: ''
        }
      },
      mounted() {
        if (this.$slots.default) {
          this.text = this.$slots.default()[0].children.trim()
        }
      }
    })
  }

}



const str = new Strings()


export { str }
